import { makeOperator } from './Operator';
export default makeOperator({
  name: 'PrivacyConsentCompleted',
  values: [{
    name: 'value',
    isValid: value => value != null
  }],
  isRefinable: true
});